

import React, { useEffect, useState } from "react";
import {
  Box,
  Text,
  Stack,
  Icon,
  Badge,
  Button,
  Divider,
  Heading, 
  useColorModeValue, 
} from "@chakra-ui/react";
import { FaScroll } from "react-icons/fa"; 
import axios from "axios";
import { Link } from "react-router-dom";
import { BASE_URL } from "../../Globalapi/Globalapi";

const NoticeBoard = () => {
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const noticeBg = useColorModeValue("white", "gray.700");
  const itemBg = useColorModeValue("white", "gray.600");

  const userType = sessionStorage.getItem("user_type") || "";

  useEffect(() => {
    const fetchNotices = async () => {
      setLoading(true);
      setError(null);

      try {
        const url = `${BASE_URL}/admin/notice_board/list_notice_board.php`;

        const response = await axios.get(url);
        if (Array.isArray(response.data)) {
          const filteredNotices = response.data.filter((notice) =>
            notice.user_types.includes(userType)
          );
          setNotices(filteredNotices.slice(0, 4));
        } else {
          setNotices([]);
        }
      } catch (err) {
        console.error("Error fetching notices:", err);
        setError("Error fetching notices");
      } finally {
        setLoading(false);
      }
    };

    fetchNotices();
  }, [userType]);

  if (loading) return <Text p={4}>Loading notices...</Text>;

  if (error)
    return (
      <Text p={4} color="red.500">
        {error}
      </Text>
    );

  return (
    <Box
      bg={noticeBg}
      p={5}
      borderRadius="xs"
      boxShadow="md"
      borderWidth="1px"
      borderColor="gray.100"
    >
      {/* ==================== Header Section ==================== */}
      <Box
        mb={4}
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Heading
          size="md"
          fontWeight="bold"
          color="teal.600"
          display="flex"
          alignItems="center"
        >
          {/* <Icon as={FaScroll} mr={3} color="teal.500" /> */}
          Notice Board
        </Heading>
        <Link
          to={
            userType === "1"
              ? "/announcement/notice"
              : "/announcement/individual/notice"
          }
        >
          <Button
            size="sm"
            variant="ghost"
            colorScheme="teal"
            fontWeight="semibold"
          >
            View All
          </Button>
        </Link>
      </Box>
      <Divider mb={4} />

      {/* ==================== Notices List ==================== */}
      <Stack spacing={3}>
        {notices.length > 0 ? (
          notices.map((notice) => (
            <Box
              key={notice.id}
              display="flex"
              flexDirection={{ base: "column", md: "row" }}
              justifyContent="space-between"
              alignItems={{ base: "flex-start", md: "center" }}
              gap={3}
              p={3}
              bg={itemBg}
              borderRadius="xs"
              // boxShadow="md"
              borderWidth="1px"
              borderColor="gray.100"
              _hover={{
                boxShadow: "lg",
                transform: "translateY(-2px)",
                transition: "0.2s",
              }}
            >
              <Box display="flex" alignItems="center" flexWrap="wrap">
                <Icon as={FaScroll} color="teal.500" boxSize={5} mr={3} />{" "}
                <Box>
                  <Text fontWeight="extrabold" fontSize="md" color="gray.800">
                    {" "}
                    {notice.title}
                  </Text>
                  <Text fontSize="xs" color="gray.500">
                    Added on: {notice.notice_date}
                  </Text>
                </Box>
              </Box>

              {/* Days Left Badge  */}
              <Badge
                colorScheme="orange"
                variant="subtle"
                px={3}
                py={1}
                borderRadius="full"
                fontWeight="bold"
                fontSize="xs"
                alignSelf={{ base: "flex-start", md: "center" }}
              >
                {notice.daysLeft || "NO DAYS LEFT INFO"}
              </Badge>
            </Box>
          ))
        ) : (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="150px"
            bg="gray.50"
            borderRadius="md"
            textAlign="center"
          >
            <Text fontSize="md" color="gray.500">
              No notices currently available.
            </Text>
          </Box>
        )}
      </Stack>
    </Box>
  );
};

export default NoticeBoard;
